module.exports = __webpack_public_path__ + "static/media/Private road 2.e2d12b43.jpg";